import { useMutation, useQueryClient, type DefaultError, type UseMutationOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = Parameters<typeof apiClient.setOrgGoals>[0];

export const useSetOrgGoals = (options?: UseMutationOptions<void, DefaultError, Params, unknown>) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: Params) => {
      await apiClient.setOrgGoals(params);
    },
    onSuccess: (...args) => {
      void queryClient.invalidateQueries({ queryKey: ["orgGoals"] });
      options?.onSuccess?.(...args);
    },
    ...options,
  });
};
